import {
  FETCH_DATA_INFORMATION,
  FETCH_DATA_SHIPPING,
  FETCH_DATA_BILLING,
  FETCH_DATA_PAYMENT,
  FETCH_DATA_SUCCESS,
  GET_PICKUP_PRICE,
  FETCH_SHIPPING_TYPE_RATES,
  FETCH_UPDATED_SHIPPING_TYPE_RATES,
  SAVE_INFORMATION,
  SAVE_SHIPPING,
  SAVE_BILLING,
  SAVE_PAYMENT,
  SAVE_EMAIL,
  setData,
  updateInformation,
  updateShipping,
  updateShippingOption,
  updateBilling,
  updatePayment,
  updateSummary,
  UPDATE_COUNTRY,
  UPDATE_REGION,
  UPDATE_COUNTRY_BILLING,
  UPDATE_REGION_BILLING,
  UPDATE_LOCATIONS,
  UPDATE_LOCATIONS_BILLING,
  SAVE_SHIPPING_OPTION,
  setFieldsLocations,
  setFieldsLocationsBilling,
  addShippingRates,
  updateShippingRates,
  increaseShippingRatesCount,
  ADD_PROMOTION_COUPON,
  REMOVE_PROMOTION_COUPON,
  setFieldInformation,
  SHOW_ERROR,
  LOGIN,
  loadedPage,
  LOGOUT,
  PLACE_ORDER,
  REVERSE_GEOCODE_LOCATION,
  MAKE_PAYPALPLUS_PAYMENT,
  UPDATE_PAYMENT_METHOD,
  REMOVE_GIFT_CARD_CODE,
  CALL_ADDRESS_AUTOFILL,
  setAddressAutofill,
} from "../actions/checkoutStore";
import { API_ERROR, API_SUCCESS, apiRequest } from "../redux/api";
import {
  setLoader,
  setRequestLoader,
  setAlertMessage,
  closeAlertMessage,
} from "../redux/ui";

const RELATIVE_BILLING_PATH = window.base_url + "/billing";
const RELATIVE_SHIPPING_PATH = window.base_url + "/shipping";

const GET_INFORMATION_URL = window.base_url + "/information/information_data";
const GET_SHIPPING_URL = window.base_url + "/shipping/shipping_data";
const GET_PICKUP_URL = window.base_url + "/shipping/pickup";
const GET_BILLING_URL = window.base_url + "/billing/billing_data";
const GET_PAYMENT_URL = window.base_url + "/payment/payment_data";
const PROMOTION_COUPON_URL = window.base_url + "/promotions";
const GIFT_CARD_URL = window.base_url + "/gift_cards";
const GET_SUCCESS_URL = window.base_url + "/success/success_data";
const UPDATE_LOCATIONS_URL = window.base_url + "/update_locations";
const UPDATE_PAYMENT_METHOD_URL = window.base_url + "/update_payment_method";
let navigateFunction = null;
export const checkoutStoreMiddleware = () => (next) => (action) => {
  next(action);
  switch (action.type) {
    case SHOW_ERROR:
      next(
        setAlertMessage({
          state: {
            active: true,
            message: action.payload.error,
            type: "error",
          },
          feature: SHOW_ERROR,
        }),
      );
      break;
    case FETCH_DATA_INFORMATION:
      next(
        setLoader({
          state: true,
          feature: FETCH_DATA_INFORMATION,
        }),
      );
      next(
        apiRequest({
          body: null,
          method: "GET",
          url: GET_INFORMATION_URL,
          feature: FETCH_DATA_INFORMATION,
          params: { preview_mode: action.payload.previewMode },
        }),
      );
      break;

    case `${FETCH_DATA_INFORMATION} ${API_SUCCESS}`:
      next(setData(action.payload));
      next(
        setFieldInformation(
          "is_mobile",
          window.matchMedia("(max-width: 992px)").matches,
        ),
      );
      next(
        setLoader({
          state: false,
          feature: FETCH_DATA_INFORMATION,
        }),
      );
      break;

    case `${FETCH_DATA_INFORMATION} ${API_ERROR}`:
      next(
        setLoader({
          state: false,
          feature: FETCH_DATA_INFORMATION,
        }),
      );
      break;

    case FETCH_DATA_SHIPPING:
      next(
        setLoader({
          state: true,
          feature: FETCH_DATA_SHIPPING,
        }),
      );
      next(
        apiRequest({
          body: null,
          method: "GET",
          url: GET_SHIPPING_URL,
          feature: FETCH_DATA_SHIPPING,
        }),
      );
      break;

    case `${FETCH_DATA_SHIPPING} ${API_SUCCESS}`:
      next(setData(action.payload));
      next(
        setLoader({
          state: false,
          feature: FETCH_DATA_SHIPPING,
        }),
      );

      break;

    case `${FETCH_DATA_SHIPPING} ${API_ERROR}`:
      next(
        setLoader({
          state: false,
          feature: FETCH_DATA_SHIPPING,
        }),
      );
      break;

    case FETCH_DATA_BILLING:
      next(
        setLoader({
          state: true,
          feature: FETCH_DATA_BILLING,
        }),
      );
      next(
        apiRequest({
          body: null,
          method: "GET",
          url: GET_BILLING_URL,
          feature: FETCH_DATA_BILLING,
        }),
      );
      break;

    case `${FETCH_DATA_BILLING} ${API_SUCCESS}`:
      next(setData(action.payload));
      next(
        setLoader({
          state: false,
          feature: FETCH_DATA_BILLING,
        }),
      );

      break;

    case `${FETCH_DATA_BILLING} ${API_ERROR}`:
      next(
        setLoader({
          state: false,
          feature: FETCH_DATA_BILLING,
        }),
      );
      break;

    case FETCH_DATA_PAYMENT:
      next(
        setLoader({
          state: true,
          feature: FETCH_DATA_PAYMENT,
        }),
      );
      next(
        apiRequest({
          body: null,
          method: "GET",
          url: GET_PAYMENT_URL,
          feature: FETCH_DATA_PAYMENT,
        }),
      );
      break;

    case `${FETCH_DATA_PAYMENT} ${API_SUCCESS}`:
      next(setData(action.payload));
      next(
        setLoader({
          state: false,
          feature: FETCH_DATA_PAYMENT,
        }),
      );
      next(loadedPage("payment"));
      break;

    case `${FETCH_DATA_PAYMENT} ${API_ERROR}`:
      next(
        setLoader({
          state: false,
          feature: FETCH_DATA_PAYMENT,
        }),
      );
      break;

    case FETCH_DATA_SUCCESS:
      next(
        setLoader({
          state: true,
          feature: FETCH_DATA_SUCCESS,
        }),
      );
      next(
        apiRequest({
          body: null,
          method: "GET",
          url: GET_SUCCESS_URL,
          feature: FETCH_DATA_SUCCESS,
        }),
      );
      break;

    case `${FETCH_DATA_SUCCESS} ${API_SUCCESS}`:
      next(setData(action.payload));
      next(
        setLoader({
          state: false,
          feature: FETCH_DATA_SUCCESS,
        }),
      );
      break;

    case `${FETCH_DATA_SUCCESS} ${API_ERROR}`:
      next(
        setLoader({
          state: false,
          feature: FETCH_DATA_SUCCESS,
        }),
      );
      break;

    case FETCH_SHIPPING_TYPE_RATES:
      next(
        apiRequest({
          params: { address: action.payload.address },
          method: "GET",
          url: `${RELATIVE_SHIPPING_PATH}/rates/${
            action.payload.type
          }?timestamp=${new Date().getTime()}`,
          feature: FETCH_SHIPPING_TYPE_RATES,
        }),
      );
      break;

    case `${FETCH_SHIPPING_TYPE_RATES} ${API_SUCCESS}`:
      next(addShippingRates(action.payload));
      break;

    case `${FETCH_SHIPPING_TYPE_RATES} ${API_ERROR}`:
      next(increaseShippingRatesCount());
      break;

    case FETCH_UPDATED_SHIPPING_TYPE_RATES:
      next(
        setRequestLoader({
          state: true,
          feature: FETCH_UPDATED_SHIPPING_TYPE_RATES,
        }),
      );
      next(
        apiRequest({
          body: null,
          method: "GET",
          url: `${RELATIVE_SHIPPING_PATH}/rates/${
            action.payload.type
          }?timestamp=${new Date().getTime()}`,
          feature: FETCH_UPDATED_SHIPPING_TYPE_RATES,
        }),
      );
      break;

    case `${FETCH_UPDATED_SHIPPING_TYPE_RATES} ${API_SUCCESS}`:
      next(updateShippingRates(action.payload));
      next(
        setRequestLoader({
          state: false,
          feature: FETCH_UPDATED_SHIPPING_TYPE_RATES,
        }),
      );
      break;

    case `${FETCH_UPDATED_SHIPPING_TYPE_RATES} ${API_ERROR}`:
      next(
        setRequestLoader({
          state: false,
          feature: FETCH_UPDATED_SHIPPING_TYPE_RATES,
        }),
      );
      break;

    case SAVE_INFORMATION:
      navigateFunction = action.payload.navigate;
      next(
        setRequestLoader({
          state: true,
          feature: SAVE_INFORMATION,
        }),
      );
      next(closeAlertMessage());
      next(
        apiRequest({
          body: action.payload.body,
          method: "PUT",
          url: action.payload.url,
          feature: SAVE_INFORMATION,
          params: {
            preview_mode: action.payload.previewMode,
          },
        }),
      );
      break;

    case `${SAVE_INFORMATION} ${API_SUCCESS}`:
      if (action.payload.content != null)
        next(updateInformation(action.payload.content));
      if (action.payload.success && !action.payload.vertical) {
        if (
          action.payload.type === "digital" ||
          action.payload.type === "pickup"
        ) {
          navigateFunction(`${RELATIVE_BILLING_PATH}/${action.token}`);
        } else {
          navigateFunction(`${RELATIVE_SHIPPING_PATH}/${action.token}`);
        }
      } else if (!action.payload.success) {
        next(
          setAlertMessage({
            state: {
              active: true,
              message: action.payload.message,
              type: "error",
            },
            feature: SAVE_INFORMATION,
          }),
        );
      }
      next(
        setRequestLoader({
          state: false,
          feature: SAVE_INFORMATION,
        }),
      );
      break;

    case `${SAVE_INFORMATION} ${API_ERROR}`:
      next(
        setAlertMessage({
          state: {
            active: true,
            message: action.payload.message,
            type: "error",
          },
          feature: SAVE_INFORMATION,
        }),
      );
      next(
        setRequestLoader({
          state: false,
          feature: SAVE_INFORMATION,
        }),
      );
      break;

    case SAVE_SHIPPING:
      navigateFunction = action.payload.navigate;
      next(
        setRequestLoader({
          state: true,
          feature: SAVE_SHIPPING,
        }),
      );
      next(closeAlertMessage());
      next(
        apiRequest({
          body: action.payload.body,
          method: "PUT",
          url: action.payload.url,
          feature: SAVE_SHIPPING,
        }),
      );
      break;

    case `${SAVE_SHIPPING} ${API_SUCCESS}`:
      if (action.payload.content != null)
        next(updateShipping(action.payload.content));
      if (action.payload.success && action.payload.go_to_next_screen) {
        if (action.payload.go_to_next_screen === "true") {
          navigateFunction(`${RELATIVE_BILLING_PATH}/${action.token}`);
        }
      } else if (
        action.payload.message !== "WAYPOINTS_OUT_OF_ZONE" &&
        action.payload.message !== "MAX_DISTANCE_EXCEEDED"
      ) {
        next(
          setAlertMessage({
            state: {
              active: true,
              message: action.payload.message,
              type: "error",
            },
            feature: SAVE_SHIPPING,
          }),
        );
      }
      next(
        setRequestLoader({
          state: false,
          feature: SAVE_SHIPPING,
        }),
      );
      break;

    case `${SAVE_SHIPPING} ${API_ERROR}`:
      next(
        setAlertMessage({
          state: {
            active: true,
            message: action.payload.message,
            type: "error",
          },
          feature: SAVE_SHIPPING,
        }),
      );
      next(
        setRequestLoader({
          state: false,
          feature: SAVE_SHIPPING,
        }),
      );
      break;

    case SAVE_SHIPPING_OPTION:
      next(
        setRequestLoader({
          state: true,
          feature: SAVE_SHIPPING_OPTION,
        }),
      );
      next(closeAlertMessage());
      next(
        apiRequest({
          body: action.payload.body,
          method: "PUT",
          url: action.payload.url,
          feature: SAVE_SHIPPING_OPTION,
        }),
      );
      break;

    case `${SAVE_SHIPPING_OPTION} ${API_SUCCESS}`:
      if (action.payload.success) {
        next(updateShippingOption(action.payload.content));
      } else {
        next(
          setAlertMessage({
            state: {
              active: true,
              message: action.payload.message,
              type: "error",
            },
            feature: SAVE_SHIPPING_OPTION,
          }),
        );
      }
      next(
        setRequestLoader({
          state: false,
          feature: SAVE_SHIPPING_OPTION,
        }),
      );
      break;

    case `${SAVE_SHIPPING_OPTION} ${API_ERROR}`:
      next(
        setAlertMessage({
          state: {
            active: true,
            message: action.payload.message,
            type: "error",
          },
          feature: SAVE_SHIPPING_OPTION,
        }),
      );
      next(
        setRequestLoader({
          state: false,
          feature: SAVE_SHIPPING_OPTION,
        }),
      );
      break;

    case SAVE_BILLING:
      next(
        setRequestLoader({
          state: true,
          feature: SAVE_BILLING,
        }),
      );
      next(closeAlertMessage());
      next(
        apiRequest({
          body: action.payload.body,
          method: "PUT",
          url: action.payload.url,
          feature: SAVE_BILLING,
        }),
      );
      break;

    case `${SAVE_BILLING} ${API_SUCCESS}`:
      if (action.payload.content != null)
        next(updateBilling(action.payload.content));
      if (!action.payload.success) {
        next(
          setAlertMessage({
            state: {
              active: true,
              message: action.payload.message,
              type: "error",
            },
            feature: SAVE_BILLING,
          }),
        );
      }
      next(
        setRequestLoader({
          state: false,
          feature: SAVE_BILLING,
        }),
      );
      break;

    case `${SAVE_BILLING} ${API_ERROR}`:
      next(
        setAlertMessage({
          state: {
            active: true,
            message: action.payload.message,
            type: "error",
          },
          feature: SAVE_BILLING,
        }),
      );
      next(
        setRequestLoader({
          state: false,
          feature: SAVE_BILLING,
        }),
      );
      break;

    case SAVE_PAYMENT:
      next(
        setRequestLoader({
          state: true,
          feature: SAVE_PAYMENT,
        }),
      );
      next(closeAlertMessage());
      next(
        apiRequest({
          body: action.payload.body,
          method: "PUT",
          url: action.payload.url,
          feature: SAVE_PAYMENT,
        }),
      );
      break;

    case `${SAVE_PAYMENT} ${API_SUCCESS}`:
      if (action.payload.content != null)
        next(updatePayment(action.payload.content));
      if (!action.payload.success) {
        next(
          setAlertMessage({
            state: {
              active: true,
              message: action.payload.message,
              type: "error",
            },
            feature: SAVE_PAYMENT,
          }),
        );
        next(
          setRequestLoader({
            state: false,
            feature: SAVE_PAYMENT,
          }),
        );
      }
      break;

    case `${SAVE_PAYMENT} ${API_ERROR}`:
      next(
        setAlertMessage({
          state: {
            active: true,
            message: action.payload.message,
            type: "error",
          },
          feature: SAVE_PAYMENT,
        }),
      );
      next(
        setRequestLoader({
          state: false,
          feature: SAVE_PAYMENT,
        }),
      );
      break;

    case PLACE_ORDER:
      next(
        setRequestLoader({
          state: true,
          feature: PLACE_ORDER,
        }),
      );
      next(closeAlertMessage());
      next(
        apiRequest({
          body: action.payload.body,
          method: "PUT",
          url: action.payload.url,
          feature: PLACE_ORDER,
        }),
      );
      break;

    case `${PLACE_ORDER} ${API_SUCCESS}`:
      if (action.payload.success) {
        if (action.payload.url != null) window.location = action.payload.url;
        if (action.payload.content != null)
          next(updatePayment(action.payload.content));
      } else {
        if (action.payload.content != null)
          next(updatePayment(action.payload.content));
        next(
          setAlertMessage({
            state: {
              active: true,
              message: action.payload.message,
              type: "error",
            },
            feature: PLACE_ORDER,
          }),
        );
      }
      next(
        setRequestLoader({
          state: false,
          feature: SAVE_PAYMENT,
        }),
      );
      break;

    case `${PLACE_ORDER} ${API_ERROR}`:
      next(
        setAlertMessage({
          state: {
            active: true,
            message: action.payload.message,
            type: "error",
          },
          feature: PLACE_ORDER,
        }),
      );
      next(
        setRequestLoader({
          state: false,
          feature: PLACE_ORDER,
        }),
      );
      break;

    case CALL_ADDRESS_AUTOFILL:
      next(
        setRequestLoader({
          state: true,
          feature: CALL_ADDRESS_AUTOFILL,
        }),
      );
      next(
        apiRequest({
          body: action.payload.body,
          method: "POST",
          url: action.payload.url,
          feature: CALL_ADDRESS_AUTOFILL,
        }),
      );
      break;

    case `${CALL_ADDRESS_AUTOFILL} ${API_SUCCESS}`:
      if (action.payload.success) {
        next(setAddressAutofill(action.payload.data));
      }
      next(
        setRequestLoader({
          state: false,
          feature: CALL_ADDRESS_AUTOFILL,
        }),
      );
      break;

    case `${CALL_ADDRESS_AUTOFILL} ${API_ERROR}`:
      next(
        setRequestLoader({
          state: false,
          feature: CALL_ADDRESS_AUTOFILL,
        }),
      );
      break;

    case UPDATE_COUNTRY:
      next(
        setRequestLoader({
          state: true,
          feature: UPDATE_COUNTRY,
        }),
      );
      next(
        apiRequest({
          body: action.payload.body,
          method: "PUT",
          url: action.payload.url,
          feature: UPDATE_COUNTRY,
        }),
      );
      break;

    case `${UPDATE_COUNTRY} ${API_SUCCESS}`:
      next(setFieldsLocations(action.payload));
      next(
        setRequestLoader({
          state: false,
          feature: UPDATE_COUNTRY,
        }),
      );
      break;

    case `${UPDATE_COUNTRY} ${API_ERROR}`:
      next(
        setRequestLoader({
          state: false,
          feature: UPDATE_COUNTRY,
        }),
      );
      break;

    case UPDATE_COUNTRY_BILLING:
      next(
        setRequestLoader({
          state: true,
          feature: UPDATE_COUNTRY_BILLING,
        }),
      );
      next(
        apiRequest({
          body: action.payload.body,
          method: "PUT",
          url: action.payload.url,
          feature: UPDATE_COUNTRY_BILLING,
        }),
      );
      break;

    case `${UPDATE_COUNTRY_BILLING} ${API_SUCCESS}`:
      next(setFieldsLocationsBilling(action.payload));
      next(
        setRequestLoader({
          state: false,
          feature: UPDATE_COUNTRY_BILLING,
        }),
      );
      break;

    case `${UPDATE_COUNTRY_BILLING} ${API_ERROR}`:
      next(
        setRequestLoader({
          state: false,
          feature: UPDATE_COUNTRY_BILLING,
        }),
      );
      break;

    case UPDATE_REGION:
      next(
        setRequestLoader({
          state: true,
          feature: UPDATE_REGION,
        }),
      );
      next(
        apiRequest({
          body: action.payload.body,
          method: "PUT",
          url: action.payload.url,
          feature: UPDATE_REGION,
        }),
      );
      break;

    case `${UPDATE_REGION} ${API_SUCCESS}`:
      next(setFieldsLocations(action.payload));
      next(
        setRequestLoader({
          state: false,
          feature: UPDATE_REGION,
        }),
      );
      break;

    case `${UPDATE_REGION} ${API_ERROR}`:
      next(
        setRequestLoader({
          state: false,
          feature: UPDATE_REGION,
        }),
      );
      break;

    case UPDATE_REGION_BILLING:
      next(
        setRequestLoader({
          state: true,
          feature: UPDATE_REGION_BILLING,
        }),
      );
      next(
        apiRequest({
          body: action.payload.body,
          method: "PUT",
          url: action.payload.url,
          feature: UPDATE_REGION_BILLING,
        }),
      );
      break;

    case `${UPDATE_REGION_BILLING} ${API_SUCCESS}`:
      next(setFieldsLocationsBilling(action.payload));
      next(
        setRequestLoader({
          state: false,
          feature: UPDATE_REGION_BILLING,
        }),
      );
      break;

    case `${UPDATE_REGION_BILLING} ${API_ERROR}`:
      next(
        setRequestLoader({
          state: false,
          feature: UPDATE_REGION_BILLING,
        }),
      );
      break;

    case UPDATE_LOCATIONS:
      next(
        setRequestLoader({
          state: true,
          feature: UPDATE_LOCATIONS,
        }),
      );
      next(
        apiRequest({
          body: action.payload.body,
          method: "PUT",
          url: action.payload.url,
          feature: UPDATE_LOCATIONS,
        }),
      );
      break;

    case `${UPDATE_LOCATIONS} ${API_SUCCESS}`:
      next(setFieldsLocations(action.payload));
      next(
        setRequestLoader({
          state: false,
          feature: UPDATE_LOCATIONS,
        }),
      );
      break;

    case `${UPDATE_LOCATIONS} ${API_ERROR}`:
      next(
        setRequestLoader({
          state: false,
          feature: UPDATE_LOCATIONS,
        }),
      );
      break;

    case UPDATE_LOCATIONS_BILLING:
      next(
        setRequestLoader({
          state: true,
          feature: UPDATE_LOCATIONS_BILLING,
        }),
      );
      next(
        apiRequest({
          body: action.payload.body,
          method: "PUT",
          url: action.payload.url,
          feature: UPDATE_LOCATIONS_BILLING,
        }),
      );
      break;

    case `${UPDATE_LOCATIONS_BILLING} ${API_SUCCESS}`:
      next(setFieldsLocationsBilling(action.payload));
      next(
        setRequestLoader({
          state: false,
          feature: UPDATE_LOCATIONS_BILLING,
        }),
      );
      break;

    case `${UPDATE_LOCATIONS_BILLING} ${API_ERROR}`:
      next(
        setRequestLoader({
          state: false,
          feature: UPDATE_LOCATIONS_BILLING,
        }),
      );
      break;

    case `${LOGOUT}`:
      next(
        setRequestLoader({
          state: true,
          feature: LOGOUT,
        }),
      );
      next(closeAlertMessage());
      next(
        apiRequest({
          body: null,
          method: "GET",
          url: action.payload.url,
          feature: LOGOUT,
        }),
      );
      break;

    case `${LOGOUT} ${API_SUCCESS}`:
      next(
        setLoader({
          state: false,
          feature: LOGOUT,
        }),
      );
      next(
        setLoader({
          state: true,
          feature: FETCH_DATA_INFORMATION,
        }),
      );
      next(
        apiRequest({
          body: null,
          method: "GET",
          url: GET_INFORMATION_URL,
          feature: FETCH_DATA_INFORMATION,
        }),
      );

      break;

    case `${LOGOUT} ${API_ERROR}`:
      next(
        setLoader({
          state: false,
          feature: LOGOUT,
        }),
      );
      break;

    case `${LOGIN}`:
      next(
        setRequestLoader({
          state: true,
          feature: LOGIN,
        }),
      );
      next(closeAlertMessage());
      next(
        apiRequest({
          body: null,
          method: "GET",
          url: action.payload.url,
          feature: LOGIN,
        }),
      );
      break;
    case `${LOGIN} ${API_SUCCESS}`:
      next(
        setLoader({
          state: false,
          feature: LOGIN,
        }),
      );

      break;

    case `${LOGIN} ${API_ERROR}`:
      next(
        setLoader({
          state: false,
          feature: LOGIN,
        }),
      );
      break;

    case GET_PICKUP_PRICE:
      next(
        apiRequest({
          body: action.payload.body,
          method: "POST",
          url: GET_PICKUP_URL,
          feature: GET_PICKUP_PRICE,
        }),
      );
      break;

    case `${GET_PICKUP_PRICE} ${API_SUCCESS}`:
      next(updateShipping(action.payload));
      break;

    case `${GET_PICKUP_PRICE} ${API_ERROR}`:
      break;

    case ADD_PROMOTION_COUPON:
      next(
        setRequestLoader({
          state: true,
          feature: ADD_PROMOTION_COUPON,
        }),
      );
      next(
        apiRequest({
          body: action.payload.body,
          method: "POST",
          url: PROMOTION_COUPON_URL,
          feature: ADD_PROMOTION_COUPON,
        }),
      );
      break;

    case `${ADD_PROMOTION_COUPON} ${API_SUCCESS}`:
      if (action.payload.content != null)
        next(updateSummary(action.payload.content));
      if (action.payload.success) {
        next(
          setAlertMessage({
            state: {
              active: true,
              message: action.payload.message,
              type: "success",
            },
            feature: ADD_PROMOTION_COUPON,
          }),
        );
      } else {
        next(
          setAlertMessage({
            state: {
              active: true,
              message: action.payload.message,
              type: "error",
            },
            feature: ADD_PROMOTION_COUPON,
          }),
        );
      }
      next(
        setRequestLoader({
          state: false,
          feature: ADD_PROMOTION_COUPON,
        }),
      );
      break;

    case `${ADD_PROMOTION_COUPON} ${API_ERROR}`:
      next(
        setAlertMessage({
          state: {
            active: true,
            message: action.payload.message,
            type: "error",
          },
          feature: ADD_PROMOTION_COUPON,
        }),
      );
      next(
        setRequestLoader({
          state: false,
          feature: ADD_PROMOTION_COUPON,
        }),
      );
      break;

    case REMOVE_PROMOTION_COUPON:
      next(
        setRequestLoader({
          state: true,
          feature: REMOVE_PROMOTION_COUPON,
        }),
      );
      next(
        apiRequest({
          method: "DELETE",
          url: `${PROMOTION_COUPON_URL}/${action.payload.id}`,
          body: JSON.stringify({ code: action.payload.id }),
          headers: {
            "Content-Type": "application/json",
          },
          feature: REMOVE_PROMOTION_COUPON,
        }),
      );
      break;

    case `${REMOVE_PROMOTION_COUPON} ${API_SUCCESS}`:
      if (action.payload.content != null)
        next(updateSummary(action.payload.content));
      if (action.payload.success) {
        next(
          setAlertMessage({
            state: {
              active: true,
              message: action.payload.message,
              type: "success",
            },
            feature: REMOVE_PROMOTION_COUPON,
          }),
        );
      } else {
        next(
          setAlertMessage({
            state: {
              active: true,
              message: action.payload.message,
              type: "error",
            },
            feature: REMOVE_PROMOTION_COUPON,
          }),
        );
      }
      next(
        setRequestLoader({
          state: false,
          feature: REMOVE_PROMOTION_COUPON,
        }),
      );
      break;

    case `${REMOVE_PROMOTION_COUPON} ${API_ERROR}`:
      next(
        setAlertMessage({
          state: {
            active: true,
            message: action.payload.message,
            type: "error",
          },
          feature: REMOVE_PROMOTION_COUPON,
        }),
      );
      next(
        setRequestLoader({
          state: false,
          feature: REMOVE_PROMOTION_COUPON,
        }),
      );
      break;

    case REVERSE_GEOCODE_LOCATION:
      next(
        setRequestLoader({
          state: true,
          feature: REVERSE_GEOCODE_LOCATION,
        }),
      );
      next(
        apiRequest({
          body: action.payload.body,
          method: "PUT",
          url: action.payload.url,
          feature: REVERSE_GEOCODE_LOCATION,
        }),
      );
      break;

    case `${REVERSE_GEOCODE_LOCATION} ${API_SUCCESS}`:
      next(
        setRequestLoader({
          state: false,
          feature: REVERSE_GEOCODE_LOCATION,
        }),
      );
      if (action.payload.success) {
        next(
          setRequestLoader({
            state: true,
            feature: UPDATE_LOCATIONS_BILLING,
          }),
        );

        const typeOfUpdate = action.payload.data.shipping
          ? UPDATE_LOCATIONS
          : UPDATE_LOCATIONS_BILLING;

        next(
          apiRequest({
            body: action.payload.data,
            method: "PUT",
            url: UPDATE_LOCATIONS_URL,
            feature: typeOfUpdate,
          }),
        );
      }
      break;
    case `${REVERSE_GEOCODE_LOCATION} ${API_ERROR}`:
      next(
        setAlertMessage({
          state: {
            active: true,
            message: action.payload.message,
            type: "error",
          },
          feature: REVERSE_GEOCODE_LOCATION,
        }),
      );
      next(
        setRequestLoader({
          state: false,
          feature: REVERSE_GEOCODE_LOCATION,
        }),
      );
      break;
    case MAKE_PAYPALPLUS_PAYMENT:
      next(
        setRequestLoader({
          state: true,
          feature: MAKE_PAYPALPLUS_PAYMENT,
        }),
      );
      next(
        apiRequest({
          body: action.payload.body,
          method: "POST",
          url: action.payload.url,
          feature: MAKE_PAYPALPLUS_PAYMENT,
        }),
      );
      next(
        setRequestLoader({
          state: false,
          feature: MAKE_PAYPALPLUS_PAYMENT,
        }),
      );
      break;

    case SAVE_EMAIL:
      next(
        setRequestLoader({
          state: true,
          feature: SAVE_EMAIL,
        }),
      );
      next(
        apiRequest({
          body: action.payload.body,
          method: "PUT",
          url: action.payload.url,
          feature: SAVE_EMAIL,
        }),
      );
      next(
        setRequestLoader({
          state: false,
          feature: SAVE_EMAIL,
        }),
      );
      break;
    case UPDATE_PAYMENT_METHOD:
      next(
        apiRequest({
          body: { payment_method_id: action.payload },
          method: "PUT",
          url: UPDATE_PAYMENT_METHOD_URL,
          feature: UPDATE_PAYMENT_METHOD,
        }),
      );
      break;
    case `${UPDATE_PAYMENT_METHOD} ${API_SUCCESS}`:
      if (action.payload.content != null && action.payload.success)
        next(updateSummary(action.payload.content));
      break;
    case REMOVE_GIFT_CARD_CODE:
      next(
        setRequestLoader({
          state: true,
          feature: REMOVE_GIFT_CARD_CODE,
        }),
      );
      next(
        apiRequest({
          method: "DELETE",
          url: `${GIFT_CARD_URL}/${action.payload.id}`,
          feature: REMOVE_GIFT_CARD_CODE,
        }),
      );
      break;

    case `${REMOVE_GIFT_CARD_CODE} ${API_SUCCESS}`:
      if (action.payload.content != null)
        next(updateSummary(action.payload.content));
      if (action.payload.success) {
        next(
          setAlertMessage({
            state: {
              active: true,
              message: action.payload.message,
              type: "success",
            },
            feature: REMOVE_GIFT_CARD_CODE,
          }),
        );
      } else {
        next(
          setAlertMessage({
            state: {
              active: true,
              message: action.payload.message,
              type: "error",
            },
            feature: REMOVE_GIFT_CARD_CODE,
          }),
        );
      }
      next(
        setRequestLoader({
          state: false,
          feature: REMOVE_GIFT_CARD_CODE,
        }),
      );
      break;

    case `${REMOVE_GIFT_CARD_CODE} ${API_ERROR}`:
      next(
        setAlertMessage({
          state: {
            active: true,
            message: action.payload?.message,
            type: "error",
          },
          feature: REMOVE_GIFT_CARD_CODE,
        }),
      );
      next(
        setRequestLoader({
          state: false,
          feature: REMOVE_GIFT_CARD_CODE,
        }),
      );
      break;
  }
};
